import React from "react"
import { Link } from "react-router-dom"

import { FiAirplay } from "react-icons/fi"

// Import menuDropdown
import ProfileMenu from "./partials/ProfileMenu"

import logo from "assets/img/logo.png"
import logoName from "assets/img/logo-name.png"

const Header = props => {

  function toggleFullscreen() {
    if (
      !document.fullscreenElement &&
      /* alternative standard method */ !document.mozFullScreenElement &&
      !document.webkitFullscreenElement
    ) {
      // current working methods
      if (document.documentElement.requestFullscreen) {
        document.documentElement.requestFullscreen()
      } else if (document.documentElement.mozRequestFullScreen) {
        document.documentElement.mozRequestFullScreen()
      } else if (document.documentElement.webkitRequestFullscreen) {
        document.documentElement.webkitRequestFullscreen(
          Element.ALLOW_KEYBOARD_INPUT
        )
      }
    } else {
      if (document.cancelFullScreen) {
        document.cancelFullScreen()
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen()
      } else if (document.webkitCancelFullScreen) {
        document.webkitCancelFullScreen()
      }
    }
  }

  function tToggle() {
    console.log('.....TOGGLE NEED TO UPDATE')
    props.toggleLeftmenu(!props.leftMenu)
  }
  return (
    <React.Fragment>
      <header id="page-topbar">
        <div className="navbar-header">
          <div className="d-flex">
            <div className="navbar-brand-box">
              <Link to="/" className="logo">
                <span className="logo-sm">
                  <img src={logo} alt="" height="32" />
                </span>
                <span className="logo-lg">
                  <img src={logoName} alt="" height="38" />
                </span>
              </Link>
            </div>

            <button
              type="button"
              onClick={() => {
                tToggle()
              }}
              className="btn btn-sm px-3 font-size-16 header-item waves-effect vertical-menu-btn"
              id="vertical-menu-btn"
            >
              <i className="fa fa-fw fa-bars" />
            </button>

          </div>

          <div className="d-flex">
            <button
                type="button"
                onClick={() => { toggleFullscreen() }}
                className="btn header-item noti-icon waves-effect font-size-20"
                data-toggle="fullscreen"
              >
                <FiAirplay />
              </button>

            <ProfileMenu />

          </div>
        </div>
      </header>
    </React.Fragment>
  )
}

export default Header